import { render } from "./BrandCard.vue?vue&type=template&id=48d4f03a&scoped=true&ts=true"
import script from "./BrandCard.vue?vue&type=script&lang=ts"
export * from "./BrandCard.vue?vue&type=script&lang=ts"

import "./BrandCard.vue?vue&type=style&index=0&id=48d4f03a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d4f03a"]])

export default __exports__